import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BomPartsImport } from 'bom/components';
import { ImportType } from 'bom/enums';
import { BomPartsImportProvider } from 'bom/states';
import { IImportPartsStatus } from 'bom/types';
import { NotificationPosition } from 'core/enums';
import { useNotificationContext } from 'core/states';
import { useJobImportActions } from 'jobs/hooks';
import { IJob } from 'jobs/types';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  job: IJob;
  onSubmitSuccess?: () => void;
}

export const ImportBom = ({ isOpen, onClose, job, onSubmitSuccess }: IProps) => {
  const { t } = useTranslation();

  const { showSuccessNotification } = useNotificationContext();

  const { createJobImport } = useJobImportActions();

  const createImportPayload = useMemo(() => ({ bom: job.id }), [job.id]);

  const handleOnSubmitSuccess = (importData: IImportPartsStatus) => {
    if (!importData?.partData?.length) {
      return;
    }

    showSuccessNotification(
      { message: t('messageJobPartsImportSuccess', { count: importData.partData.length }) },
      NotificationPosition.TOP
    );

    onSubmitSuccess?.();
  };

  return (
    <BomPartsImportProvider
      createImport={createJobImport}
      createImportPayload={createImportPayload}
      type={ImportType.JOB}
      onSubmitSuccess={handleOnSubmitSuccess}
      isAlternateVersionEnabled={false}
    >
      <BomPartsImport isOpen={isOpen} onClose={onClose} />
    </BomPartsImportProvider>
  );
};
